import { IntegrationrolesProviderStateType } from '../../components/forms/roles/types';

export const integrationRolesProviderStateMock: IntegrationrolesProviderStateType = {
  eleveoRoles: [],
  isEleveoRolesError: false,
  isEleveoRolesLoading: false,
  isPermittedForEleveoRoles: true,

  integrationRoles: [],
  isIntegrationRolesError: false,
  isIntegrationRolesLoading: false,
  isIntegrationDataFilled: false,
  isPermittedForIntegrationRoles: true,

  conflictedRoles: {},
  conflictedOptions: [],
  roleMapping: {},
};
